module.exports = "../study/imgs/maps/Nagano/S8/Helth/Mosquito/Nagano_Mosquito_MRI_RCP45_Mid.png";